(function (runtime) {
    "use strict";

    /*
      入荷予告（Coming Soon）のカード描画（store #69・テーマ側）
      ・自動コレクションの商品 payload を受け取り、商品ページへのリンクと予告カードを組み立てる
      ・タグ由来の状態は時刻で変えない。販売開始を過ぎた coming は「まもなく販売開始」で残す
      ・会員のお知らせは署名つきの受け渡し口へ、メールの印つきの方だけ直接の口へ送る
      ・商品ページの通知も同じ部品を使う。store-management への同期は別工程
    */

    var CODE_PATTERN = /^\d{7}$/;
    var CURRENCY_PATTERN = /^[A-Z]{3}$/;
    // 送る前の軽い検査だけ。厳密な判定はサーバー側が行う。
    var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var SECOND_MS = 1000;
    var MINUTE_MS = 60 * SECOND_MS;
    var HOUR_MS = 60 * MINUTE_MS;
    var DAY_MS = 24 * HOUR_MS;
    var REQUEST_TIMEOUT_MS = 15000;
    var STORAGE_PREFIX = "nk-upcoming-notify:";
    var DONE_CLASS = "nk-up__btn--done";
    var dialogs = new WeakMap();
    var controllers = typeof WeakMap === "function" ? new WeakMap() : null;

    /* #430（2026-10-14 オーナー決定「ログイン中の会員は、パソコンとスマホで『✓ Reminder set』の表示をそろえる」）:
       ログイン中の会員だけ、サーバーの台帳（まだ送っていない申し込み）に ✓ を合わせる。
       ・問い合わせはページを読み終えてから1回だけ（受け渡し口 NKAppProxy → /apps/nk/sale-notify/status）
       ・うまく読めたときだけ当てる。失敗・口が閉じている・未ログインのときは、この端末の覚えのまま
       ・送っている最中の札・小窓が開いている札・答えを待つ間にこの端末で申し込み／取り消しをした札は触らない */
    var STATUS_PATH = "sale-notify/status";
    var STATUS_TIMEOUT_MS = 15000;
    var MAX_STATUS_CODES = 500;
    /* #431（2026-10-14 オーナー「パソコンで取り消したのにスマホは ✓ のまま」「全部がシームレスに動くように」）:
       ・ログイン中は、サーバーの台帳（まだ送っていない申し込み）を正として ✓ をそろえる（どの道で申し込んだ覚えでも）
       ・この端末で申し込み・取り消しをした品は、1分だけこの端末の覚えを正とする
         （その前に出した問い合わせの答えが後から届いても戻さない。問い合わせは15秒で打ち切るので1分あれば足りる）
       ・画面に戻ったとき（visibilitychange）・戻る操作（pageshow）で問い合わせ直す。画面に戻るほうは端末ごとに1分に1回まで
       ・同じ端末の別のタブで変えた分は、その場で写す（storage の知らせ）
       ・ページに部品がいくつあっても、問い合わせはページで1本（答えは全部の部品に当てる） */
    // この端末で申し込み・取り消しをした記録（「時刻:1」＝申し込んだ／「時刻:0」＝取り消した）。30日で片付ける
    var LOCAL_AT_PREFIX = "nk-upcoming-notify-at:";
    var LOCAL_GRACE_MS = MINUTE_MS;
    var LOCAL_KEEP_MS = 30 * DAY_MS;
    var SYNC_AT_KEY = "nk-upcoming-sync-at";
    var RESYNC_MIN_MS = MINUTE_MS;
    var hubs = typeof WeakMap === "function" ? new WeakMap() : null;
    // ログインから戻った品はページ全体で一度だけ申し込む（部品の作り直しでも重ねない）。
    var remindedPages = typeof WeakMap === "function" ? new WeakMap() : null;
    var MEMBER_PATH = "sale-notify/member";
    // 一度でも問い合わせたページ（部品を全部片付けた後に足し直しても、1分に1回を守る）
    var syncedPages = typeof WeakMap === "function" ? new WeakMap() : null;
    // ページの DOMContentLoaded を見たか（受け渡し口は節の中で defer で読む＝この部品より後に走るため、そこまで待つ）
    var domReady = false;

    function find(scope, name) {
        return scope.querySelector('[data-nk-upcoming="' + name + '"]');
    }

    function setText(element, value) {
        if (element) {
            element.textContent = value === null || value === undefined ? "" : String(value);
        }
    }

    function setHidden(element, hidden) {
        if (element) {
            element.hidden = Boolean(hidden);
        }
    }

    function datasetText(root, name) {
        var value = root.dataset[name];
        return value === undefined ? "" : value;
    }

    function fillTemplate(template, values) {
        return String(template).replace(
            /\{\{\s*([a-z_]+)\s*\}\}|\{([a-z_]+)\}/g,
            function (whole, doubleKey, singleKey) {
                var key = doubleKey || singleKey;
                return Object.prototype.hasOwnProperty.call(values, key)
                    ? String(values[key])
                    : whole;
            }
        );
    }

    // 販売開始は UTC の ISO 文字列（例 2026-09-07T16:00:00Z）だけを受け付ける。
    function parseTime(value) {
        if (typeof value !== "string" || value.trim() === "") {
            return null;
        }
        var text = value.trim();
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]00:00)$/i.test(text)) {
            return null;
        }
        var parsed = Date.parse(text);
        return Number.isNaN(parsed) ? null : parsed;
    }

    function pad2(value) {
        return value < 10 ? "0" + value : String(value);
    }

    function safeImageUrl(value) {
        if (typeof value !== "string") {
            return "";
        }
        var text = value.trim();
        // https の絶対URLだけ。改行や引用符を含むものは style 属性を壊すので捨てる。
        if (!/^https:\/\/(?:cdn\.shopify\.com\/|nihonkosho\.com\/cdn\/)[^\s"'()\\]+$/i.test(text)) {
            return "";
        }
        return text;
    }

    // 許可した2つの CDN は、どちらも width= で縮小版を返す。
    function sizedImageUrl(url, width) {
        if (!safeImageUrl(url)) {
            return url;
        }
        // #321: Liquid 側で width=800 が付いたまま届く。足すと「width=800&width=800」の別の住所になり、
        //       先回りの温めから外れていた。いまの width= を外してから付け直す（置き換え）
        var base = url.replace(/([?&])width=\d+(&|$)/g, function (match, head, tail) { return tail ? head : ""; });
        return base + (base.indexOf("?") === -1 ? "?" : "&") + "width=" + width;
    }

    // 商品への道は同じ店の相対パスだけを受け付ける。
    function safeProductUrl(value, handle) {
        if (typeof value !== "string") { return ""; }
        var text = value.trim();
        if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9][a-z0-9-]*$/i.test(text)) { return ""; }
        return text.slice(text.lastIndexOf("/") + 1) === handle ? text : "";
    }

    function normalizeCard(raw) {
        if (!raw || typeof raw !== "object") { return null; }
        var handle = typeof raw.handle === "string" ? raw.handle.trim() : "";
        var title = typeof raw.title === "string" ? raw.title.trim() : "";
        var url = safeProductUrl(raw.url, handle);
        if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) || !title || !url) { return null; }
        var price = null;
        if (raw.price && typeof raw.price === "object") {
            var amount = Number(raw.price.amount);
            var currency = typeof raw.price.currency === "string" ? raw.price.currency.trim().toUpperCase() : "";
            if (isFinite(amount) && amount >= 0 && CURRENCY_PATTERN.test(currency)) {
                price = {amount: amount, currency: currency};
            }
        }
        return {
            // 通知 API の管理番号は従来どおり7桁。番号を推測して送らない。
            code: CODE_PATTERN.test(handle) ? handle : "",
            handle: handle,
            title: title,
            artist: typeof raw.artist === "string" ? raw.artist.trim() : "",
            price: price,
            image: safeImageUrl(raw.image),
            url: url,
            state: ["sold", "draw", "coming", "available"].indexOf(raw.state) !== -1 ? raw.state : "coming",
            saleStartsAt: parseTime(raw.sale_starts_at)
        };
    }

    function normalizeCards(payload) {
        var list = payload && typeof payload === "object" && Array.isArray(payload.cards) ? payload.cards : [];
        var cards = [];
        var seen = {};
        list.forEach(function (raw) {
            var card = normalizeCard(raw);
            if (card && !Object.prototype.hasOwnProperty.call(seen, card.handle)) {
                seen[card.handle] = true;
                cards.push(card);
            }
        });
        // 自動コレクションの並びを保つ。時刻や管理番号では並べ直さない。
        return cards;
    }

    function formatPrice(locale, price) {
        if (!price) {
            return "";
        }
        var whole = price.amount % 1 === 0;
        try {
            return new Intl.NumberFormat(locale || undefined, {
                style: "currency",
                currency: price.currency,
                minimumFractionDigits: whole ? 0 : 2,
                maximumFractionDigits: whole ? 0 : 2
            }).format(price.amount);
        } catch (error) {
            return price.currency + " " + (whole ? String(price.amount) : price.amount.toFixed(2));
        }
    }

    // 販売開始は世界標準時で書く（決定85）。年は出さない。
    function formatUtc(locale, ms) {
        var date = new Date(ms);
        try {
            return new Intl.DateTimeFormat(locale || undefined, {
                timeZone: "UTC",
                weekday: "short",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23"
            }).format(date);
        } catch (error) {
            return date.toISOString().replace("T", " ").slice(5, 16);
        }
    }

    // 読む人の地域の曜日と時刻を1行だけ添える（決定91）。UTC の地域では出さない。
    function formatLocal(locale, ms, template) {
        var zone = "";
        try {
            zone = new Intl.DateTimeFormat().resolvedOptions().timeZone || "";
        } catch (error) {
            zone = "";
        }
        if (!zone || zone === "UTC" || zone === "Etc/UTC") {
            return "";
        }
        var text;
        try {
            text = new Intl.DateTimeFormat(locale || undefined, {
                timeZone: zone,
                weekday: "short",
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23"
            }).format(new Date(ms));
        } catch (error) {
            return "";
        }
        return fillTemplate(template, {zone: zone, time: text});
    }

    function countdownParts(remainingMs) {
        var remaining = Math.max(0, remainingMs);
        return {
            days: Math.floor(remaining / DAY_MS),
            hours: Math.floor((remaining % DAY_MS) / HOUR_MS),
            minutes: Math.floor((remaining % HOUR_MS) / MINUTE_MS),
            seconds: Math.floor((remaining % MINUTE_MS) / SECOND_MS)
        };
    }

    // 既存の安全化関数を維持する。予告カードでは説明HTMLを描画しない。
    function sanitizeHtml(html) {
        var text = String(html || "");
        text = text.replace(/<!--[\s\S]*?-->/g, "");
        text = text.replace(/<(script|style|iframe|object|embed|svg|math|form|link|meta|base|template)\b[\s\S]*?<\/\1\s*>/gi, "");
        text = text.replace(/<(script|style|iframe|object|embed|svg|math|form|link|meta|base|template|input|button)\b[^>]*\/?>/gi, "");
        // on*= の属性と、javascript:/data: の飛び先を外す。
        text = text.replace(/\son[a-z]+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
        text = text.replace(/\s(href|src|xlink:href)\s*=\s*("\s*(?:javascript|data|vbscript):[^"]*"|'\s*(?:javascript|data|vbscript):[^']*')/gi, "");
        return text;
    }

    function validEmail(value) {
        var text = typeof value === "string" ? value.trim() : "";
        return text.length > 0 && text.length <= 254 && EMAIL_PATTERN.test(text);
    }

    function kxFromLocation(location) {
        var search = location && typeof location.search === "string" ? location.search : "";
        var match = /[?&]_kx=([^&#]+)/.exec(search);
        if (!match) {
            return "";
        }
        try {
            return decodeURIComponent(match[1]);
        } catch (error) {
            return "";
        }
    }

    function readTexts(root) {
        return {
            badge: datasetText(root, "nkUpcomingBadge"),
            shortly: datasetText(root, "nkUpcomingShortly"),
            sold: datasetText(root, "nkUpcomingSold"),
            draw: datasetText(root, "nkUpcomingDraw"),
            comingTitle: datasetText(root, "nkUpcomingComingTitle"),
            comingLead: datasetText(root, "nkUpcomingComingLead"),
            shortlyNote: datasetText(root, "nkUpcomingShortlyNote"),
            openPiece: datasetText(root, "nkUpcomingOpenPiece"),
            whenLabel: datasetText(root, "nkUpcomingWhenLabel"),
            utcSuffix: datasetText(root, "nkUpcomingUtcSuffix"),
            localLine: datasetText(root, "nkUpcomingLocalLine"),
            cdLabel: datasetText(root, "nkUpcomingCdLabel"),
            unitDays: datasetText(root, "nkUpcomingUnitDays"),
            unitHours: datasetText(root, "nkUpcomingUnitHours"),
            unitMinutes: datasetText(root, "nkUpcomingUnitMinutes"),
            unitSeconds: datasetText(root, "nkUpcomingUnitSeconds"),
            notify: datasetText(root, "nkUpcomingNotify"),
            /* 2026-09-22（#261）: 狭い画面用の短い言い方（「Notify me」）。
               長い方は171px幅のカードで2行になり、オーナーから直しの指摘が出た。 */
            notifyShort: datasetText(root, "nkUpcomingNotifyShort"),
            sending: datasetText(root, "nkUpcomingSending"),
            done: datasetText(root, "nkUpcomingDone"),
            doneButton: datasetText(root, "nkUpcomingDoneButton"),
            /* #430（2026-10-14 オーナー指摘「押した後のボタンの縦幅を押す前とそろえて」）:
               押した後の札の、スマホの細いカード用の短い言い方。長い方は細いカードで2行になり、
               高さが 52px → 64px に変わっていた。渡されていなければ長い方をそのまま使う。 */
            doneShort: datasetText(root, "nkUpcomingDoneShort"),
            // #430: 予告品の小窓の1行「販売開始の約10分前にメールでお知らせします」（再入荷の小窓には渡さない）
            remindNote: datasetText(root, "nkUpcomingRemindNote"),
            already: datasetText(root, "nkUpcomingAlready"),
            unavailable: datasetText(root, "nkUpcomingUnavailable"),
            emailLabel: datasetText(root, "nkUpcomingEmailLabel"),
            emailPlaceholder: datasetText(root, "nkUpcomingEmailPlaceholder"),
            send: datasetText(root, "nkUpcomingSend"),
            cancel: datasetText(root, "nkUpcomingCancel"),
            emailInvalid: datasetText(root, "nkUpcomingEmailInvalid"),
            emailUnknown: datasetText(root, "nkUpcomingEmailUnknown"),
            rateLimited: datasetText(root, "nkUpcomingRateLimited"),
            error: datasetText(root, "nkUpcomingError"),
            // #431（2026-10-14 オーナー決定）: 申し込んだ後に「✓ We'll email you」を押すと取り消せる
            stopTitle: datasetText(root, "nkUpcomingStopTitle"),
            stopButton: datasetText(root, "nkUpcomingStopButton"),
            keepButton: datasetText(root, "nkUpcomingKeepButton"),
            stopped: datasetText(root, "nkUpcomingStopped"),
            viewAll: datasetText(root, "nkUpcomingViewAll"),
            // 2026-09-22 オーナー決定: 発売日を写真の枠の外・上に。当日は「本日発売」
            onSaleToday: datasetText(root, "nkUpcomingOnSaleToday")
        };
    }

    function readInlinePayload(root) {
        var script = root.querySelector('script[type="application/json"][data-nk-upcoming-payload]');
        if (!script) {
            return null;
        }
        var text = script.textContent || "";
        if (!text.trim()) {
            return null;
        }
        try {
            return JSON.parse(text);
        } catch (error) {
            return null;
        }
    }

    /* 覚えの値: "kx"＝メールの印で申し込んだ／"1"＝メールアドレスで申し込んだ（前からの値・会員のアドレス以外も含む）。
       #430: "m"＝ログイン中の会員が自分のアカウントのアドレスで申し込んだ／"s"＝サーバーの答え（端末をまたいだそろえ）で付けた。
       #431（2026-10-14 オーナー確認「同じアドレス・同じ会員です」）: ログイン中は、どの値でもサーバーの台帳に無ければ外す
       （前は "m" と "s" だけ外していた＝前からの "1"・"kx" の ✓ が、別の端末で取り消しても残り続けた）。
       ログイン中の申し込み・取り消しは、署名つきの顧客番号で本人を決める（本文にアドレスを入れない）。
       ログインしていない方の取り消しは、申し込んだのと同じ道で送る（印で申し込んでいない品を印で取り消すと空振りする）。 */
    var STORED_VALUES = {kx: "kx", email: "1", member: "m", synced: "s"};

    function rememberedValue(state, code) {
        if (!state.storage) {
            return "";
        }
        try {
            var value = state.storage.getItem(STORAGE_PREFIX + code);
            return typeof value === "string" ? value : "";
        } catch (error) {
            return "";
        }
    }

    function rememberedVia(state, code) {
        var value = rememberedValue(state, code);
        return value === "kx" ? "kx" : ((value === "1" || value === "m" || value === "s") ? "email" : "");
    }

    function remember(state, code, via) {
        if (!state.storage) {
            return;
        }
        try {
            state.storage.setItem(STORAGE_PREFIX + code, STORED_VALUES[via] || "1");
        } catch (error) {
            // 覚えられなくても登録そのものは済んでいるので、黙って進む。
        }
    }

    // #431: 取り消せたら「申し込み済み」の覚えも消す（開き直しても元の「Email me」に戻る）
    function forget(state, code) {
        if (!state.storage) {
            return;
        }
        try {
            state.storage.removeItem(STORAGE_PREFIX + code);
        } catch (error) {
            // 消せなくても取り消しそのものは済んでいるので、黙って進む。
        }
    }

    /* #430/#431: この端末で申し込み・取り消しができたときに呼ぶ（サーバーに合わせたときは呼ばない）。
       ・答えを待っている間の変更は、届いた答えより新しい＝その品にはサーバーの答えを当てない
       ・覚えている答えも同じに直す（札を作り直したときに古い答えで戻さない）
       ・申し込んだか取り消したかを、時刻つきでページの中と端末の覚えの両方に記録する（別のタブにも効かせる）。
         ✓ の覚え（nk-upcoming-notify:）とは別に書く＝覚えの書き換え・削除だけ失敗しても、記録で正しく決まる */
    function noteLocalChange(state, code, joined) {
        var hub = state.hub;
        var at = Math.floor(state.now());
        if (hub) {
            hub.touched[code] = Boolean(joined);
            hub.local[code] = {joined: Boolean(joined), at: at};
            hub.seenAt[code] = Math.max(hub.seenAt[code] || 0, at);
            if (hub.pending) {
                if (joined) {
                    hub.pending[code] = true;
                } else {
                    delete hub.pending[code];
                }
            }
        }
        if (!state.storage) {
            return;
        }
        try {
            state.storage.setItem(LOCAL_AT_PREFIX + code, String(at) + ":" + (joined ? "1" : "0"));
        } catch (error) {
            // 覚えられなくても、このページの中の記録（hub.local）で同じ扱いになる。
        }
    }

    // 記録の文字列を読む。形が違えば null
    function parseRecord(value) {
        var match = typeof value === "string" ? /^(\d{1,16}):([01])$/.exec(value) : null;
        return match ? {at: Number(match[1]), joined: match[2] === "1"} : null;
    }

    // 端末の覚えにある記録。無い・読めない・壊れている・30日を過ぎたときは null（壊れた記録・古い記録は片付ける）
    function storedRecord(state, code, nowMs) {
        if (!state.storage) {
            return null;
        }
        var value;
        try {
            value = state.storage.getItem(LOCAL_AT_PREFIX + code);
        } catch (error) {
            return null;
        }
        if (value === null || value === undefined) {
            return null;
        }
        var record = parseRecord(value);
        if (record && nowMs - record.at < LOCAL_KEEP_MS) {
            return record;
        }
        try {
            state.storage.removeItem(LOCAL_AT_PREFIX + code);
        } catch (error) {
            // 片付けられなくても、次に読んだときも同じく使わないだけ。
        }
        return null;
    }

    function make(state, tagName, className, marker) {
        var node = state.documentRef.createElement(tagName);
        if (className) {
            node.setAttribute("class", className);
        }
        if (marker) {
            node.setAttribute("data-nk-upcoming", marker);
        }
        return node;
    }

    function makeCell(state, marker, unit) {
        var cell = make(state, "span", "nk-up__cell");
        var number = make(state, "span", "nk-up__num", marker);
        setText(number, "0");
        var label = make(state, "i", "nk-up__unit");
        setText(label, unit);
        cell.appendChild(number);
        cell.appendChild(label);
        return {cell: cell, number: number};
    }

    function setImage(element, url, width) {
        if (!element || !url) {
            return;
        }
        element.style.backgroundImage = 'url("' + sizedImageUrl(url, width) + '")';
    }

    /* 2026-09-22: 写真の枠の外・上に出す発売日。年は出さない（他の表示と同じ扱い） */
    function formatSaleDate(state, ms) {
        var now = new Date(state.now());
        var date = new Date(ms);
        /* #301: 発売時刻を過ぎた品に過去の日付を出さない（解禁が遅れて予告のまま残った品で
           「9月21日」のような古い日付が並んでいた）。今日の品と同じ言葉にする */
        if (ms <= now.getTime()) {
            return state.texts.onSaleToday || "";
        }
        if (date.getFullYear() === now.getFullYear()
            && date.getMonth() === now.getMonth()
            && date.getDate() === now.getDate()) {
            return state.texts.onSaleToday || "";
        }
        try {
            return new Intl.DateTimeFormat(state.locale || undefined, {
                weekday: "short",
                month: "short",
                day: "numeric"
            }).format(date);
        } catch (error) {
            return date.toISOString().slice(0, 10);
        }
    }

    function buildItem(state, card) {
        var texts = state.texts;
        var item = make(state, "article", "nk-up__item", "item");
        item.setAttribute("data-nk-upcoming-code", card.code);

        item.setAttribute("data-nk-state", card.state);
        item.setAttribute("data-nk-state-label", stateLabel(state, card, false));
        item.setAttribute("data-nk-state-shortly-label", texts.shortly);
        if (card.state === "coming" && card.saleStartsAt !== null) {
            item.setAttribute("data-nk-sale-starts", new Date(card.saleStartsAt).toISOString());
        }
        var badge = null;
        var body = make(state, "div", "nk-up__body");
        /* 2026-09-22 オーナー決定: 発売日を「写真の枠の外・上」に1行だけ出す。
           ・日付だけ（時刻は出さない。真下のカウントダウンが正確に伝える）
           ・お客さまの現地の日付で「今日」なら「本日発売」に差し替える
           #301: 商品ページでも同じ1行を出す（案内文は「表示の時刻に発売」なのに、
                 残り時間だけで日付がどこにも無かった）。置き場は残り時間の上。 */
        var saleDate = null;
        if (card.state === "coming" && card.saleStartsAt !== null) {
            saleDate = make(state, "span", "nk-up__saledate", "sale-date");
            setText(saleDate, formatSaleDate(state, card.saleStartsAt));
            item.appendChild(saleDate);
        }
        if (!state.productMode) {
            var frame = make(state, "a", "nk-up__frame", "image-link");
            frame.setAttribute("href", card.url);
            frame.setAttribute("aria-label", card.title + " — " + texts.openPiece);
            var image = make(state, "span", "nk-up__img", "image");
            image.setAttribute("role", "img");
            image.setAttribute("aria-label", card.title);
            // #321: 枠は PC で 296px・スマホで約 123px。800 は大きすぎたので 640（新着の写真と同じ幅の候補）
            setImage(image, card.image, 640);
            var haze = make(state, "span", "nk-up__haze");
            haze.setAttribute("aria-hidden", "true");
            badge = make(state, "span", "nk-up__badge", "badge");
            setText(badge, stateLabel(state, card, false));
            setHidden(haze, card.state === "available");
            haze.appendChild(badge);
            frame.appendChild(image);
            frame.appendChild(haze);
            item.appendChild(frame);
            var name = make(state, "h3", "nk-up__name");
            var link = make(state, "a", "nk-up__piece-link", "title");
            link.setAttribute("href", card.url);
            // #270: 作品名は商品名まるごと（末尾の商品コードまで）。新着・抽選・横棚と同じ。
            setText(link, card.title);
            name.appendChild(link);
            body.appendChild(name);
            // 2026-10-14 オーナー決定（#431）: カードに絵師の行は出さない。絵師の無い本や、名前が2行になる絵師で
            // カードごとに行数が変わり、「Email me」のボタンが横一列にそろわなかったため（トップ・一覧とも）
            var price = make(state, "p", "nk-up__price", "price");
            setText(price, formatPrice(state.locale, card.price));
            setHidden(price, !card.price);
            body.appendChild(price);
        }
        var when = make(state, "p", "nk-up__when");
        var whenLabel = make(state, "span", "nk-up__whenlabel", "when-label");
        setText(whenLabel, texts.whenLabel);
        var utc = make(state, "span", "nk-up__utc", "utc");
        setText(utc, card.saleStartsAt === null ? "" : formatUtc(state.locale, card.saleStartsAt) + " " + texts.utcSuffix);
        when.appendChild(whenLabel);
        when.appendChild(state.documentRef.createTextNode(" "));
        when.appendChild(utc);
        if (card.saleStartsAt !== null && card.state === "coming") { body.appendChild(when); }

        var local = make(state, "p", "nk-up__local", "local");
        var localText = card.saleStartsAt === null ? "" : formatLocal(state.locale, card.saleStartsAt, texts.localLine);
        setText(local, localText);
        setHidden(local, !localText);
        if (card.saleStartsAt !== null && card.state === "coming") { body.appendChild(local); }

        var countdown = make(state, "div", "nk-up__cd", "countdown");
        countdown.setAttribute("role", "timer");
        var cdLabel = make(state, "span", "nk-up__cdlabel", "cd-label");
        setText(cdLabel, texts.cdLabel);
        countdown.appendChild(cdLabel);
        var cells = make(state, "span", "nk-up__cells", "cells");
        var made = {
            days: makeCell(state, "cd-days", texts.unitDays),
            hours: makeCell(state, "cd-hours", texts.unitHours),
            minutes: makeCell(state, "cd-minutes", texts.unitMinutes),
            seconds: makeCell(state, "cd-seconds", texts.unitSeconds)
        };
        var cellNodes = {
            days: made.days.number,
            hours: made.hours.number,
            minutes: made.minutes.number,
            seconds: made.seconds.number
        };
        cells.appendChild(made.days.cell);
        cells.appendChild(made.hours.cell);
        cells.appendChild(made.minutes.cell);
        cells.appendChild(made.seconds.cell);
        countdown.appendChild(cells);
        if (card.saleStartsAt !== null && card.state === "coming") { body.appendChild(countdown); }

        var notify = make(state, "button", "nk-up__btn", "notify");
        notify.setAttribute("type", "button");
        /* 2026-09-22（#261）: 長い言い方と短い言い方の両方をHTMLに置き、
           どちらを見せるかはCSSに任せる。画面を回しても正しく切り替わる。 */
        var notifyLong = make(state, "span", "nk-up__btnlong", "notify-long");
        var notifyShort = make(state, "span", "nk-up__btnshort", "notify-short");
        setText(notifyLong, texts.notify);
        setText(notifyShort, texts.notifyShort ? texts.notifyShort : texts.notify);
        notify.appendChild(notifyLong);
        notify.appendChild(notifyShort);
        if (card.state === "coming" && card.code) { body.appendChild(notify); }

        var form = make(state, "div", "nk-up__form", "form");
        form.hidden = true;
        // #431: 取り消しの形で開いたときだけ出す問いの1行（「この作品のお知らせをやめますか？」）
        var stopLead = make(state, "p", "nk-up__stoplead", "stop-lead");
        stopLead.hidden = true;
        form.appendChild(stopLead);
        var label = make(state, "label", "nk-up__label");
        var labelText = make(state, "span", "nk-up__labeltext", "email-label");
        setText(labelText, texts.emailLabel);
        var input = make(state, "input", "nk-up__input", "email");
        input.setAttribute("type", "email");
        input.setAttribute("autocomplete", "email");
        input.setAttribute("inputmode", "email");
        input.setAttribute("placeholder", texts.emailPlaceholder);
        // 古いメール欄は残すが、会員は欄を隠して本文にもアドレスを入れない。
        input.value = state.memberEmail;
        if (memberIdentifier(state)) {
            input.readOnly = true;
            input.setAttribute("readonly", "");
        }
        label.appendChild(labelText);
        label.appendChild(input);
        form.appendChild(label);
        // #241 ボットよけ: 人には見えない欄。埋まっていたらサーバーが機械の書き込みとみなす
        var trap = make(state, "input", "nk-up__hp", "website");
        trap.setAttribute("type", "text");
        trap.setAttribute("name", "website");
        trap.setAttribute("tabindex", "-1");
        trap.setAttribute("autocomplete", "off");
        trap.setAttribute("aria-hidden", "true");
        trap.setAttribute("style", "position:absolute;left:-10000px;width:1px;height:1px;overflow:hidden");
        form.appendChild(trap);
        var row = make(state, "div", "nk-up__formrow");
        var send = make(state, "button", "nk-up__btn nk-up__btn--small", "send");
        send.setAttribute("type", "button");
        setText(send, texts.send);
        var cancel = make(state, "button", "nk-up__cancel", "cancel");
        cancel.setAttribute("type", "button");
        setText(cancel, texts.cancel);
        row.appendChild(send);
        row.appendChild(cancel);
        form.appendChild(row);
        // 入力欄はカードに置かず、開いた作品の分だけ共通の小窓へ移す。

        var status = make(state, "p", "nk-up__status", "status");
        status.setAttribute("role", "status");
        status.hidden = true;
        body.appendChild(status);

        item.appendChild(body);

        var entry = {
            card: card,
            element: item,
            cells: cellNodes,
            countdown: countdown,
            cdLabel: cdLabel,
            cellsBox: cells,
            badge: badge,
            notify: notify,
            notifyLong: notifyLong,
            notifyShort: notifyShort,
            form: form,
            stopLead: stopLead,
            label: label,
            mode: "join",
            input: input,
            trap: trap,
            send: send,
            cancel: cancel,
            status: status,
            saleDate: saleDate,
            statusHome: body,
            busy: false,
            joinedVia: rememberedVia(state, card.code)
        };
        entry.done = entry.joinedVia !== "";
        if (entry.done) {
            markDone(state, entry);
        }
        bindItem(state, entry);
        return entry;
    }

    /* 🛑 通知ボタンの文字はここだけで書き換える。entry.notify へ直接 setText すると、
       長い言い方・短い言い方の2枚の span ごと消えてしまい、狭い画面で2行に戻る。 */
    function setNotifyLabel(entry, longText, shortText) {
        if (!entry.notify) { return; }
        if (entry.notifyLong && entry.notifyShort) {
            setText(entry.notifyLong, longText);
            setText(entry.notifyShort, shortText ? shortText : longText);
            return;
        }
        setText(entry.notify, longText);
    }

    // 押した後の札（✓ ＋言葉）。細いカードでは短い言い方（#430）
    function setDoneLabel(state, entry) {
        var longText = state.texts.doneButton || state.texts.done;
        setNotifyLabel(entry, "✓ " + longText, "✓ " + (state.texts.doneShort || longText));
    }

    function markDone(state, entry) {
        entry.done = true;
        entry.busy = false;
        // #430（2026-10-14 オーナー報告「申し込んですぐ取り消そうとしたら Cancel reminder が押せない」）:
        //   送っている間に止めた小窓の送るボタンを、ここで元に戻す（成功した回は setBusy(false) を通らないため、
        //   押せないまま残り、続けて開いた取り消しの小窓のボタンが押せなかった）
        entry.send.disabled = false;
        setText(entry.send, state.texts.send);
        setDoneLabel(state, entry);
        // #431: 済みのボタンは押すと取り消しの小窓を開く＝押せる見た目のまま（送っている間だけ押せない）。
        entry.notify.setAttribute("aria-disabled", "false");
        if (entry.notify.classList) {
            entry.notify.classList.add(DONE_CLASS);
        }
        setHidden(entry.form, true);
        var dialog = dialogs.get(state.documentRef);
        if (dialog && dialog.entry === entry) { dialog.closeButton.focus(); }
    }

    /* #431/#430: 「申し込み済み」の見た目と覚えを外し、「Email me」に戻す
       （取り消せたとき・ログイン中の会員の申し込みがサーバーに無かったとき） */
    function unmarkDone(state, entry) {
        forget(state, entry.card.code);
        entry.done = false;
        entry.joinedVia = "";
        if (entry.notify.classList && typeof entry.notify.classList.remove === "function") {
            entry.notify.classList.remove(DONE_CLASS);
        }
        setNotifyLabel(entry, state.texts.notify, state.texts.notifyShort);
        entry.notify.setAttribute("aria-disabled", "false");
        setHidden(entry.form, true);
    }

    function showStatus(entry, message) {
        setText(entry.status, message);
        setHidden(entry.status, !message);
    }

    function setBusy(state, entry, busy) {
        entry.busy = busy;
        entry.notify.setAttribute("aria-disabled", String(busy));
        entry.send.disabled = busy;
        if (busy) {
            setNotifyLabel(entry, state.texts.sending);
            setText(entry.send, state.texts.sending);
        } else if (entry.done) {
            setDoneLabel(state, entry);
            setText(entry.send, state.texts.send);
        } else {
            setNotifyLabel(entry, state.texts.notify, state.texts.notifyShort);
            setText(entry.send, state.texts.send);
        }
    }

    // ページに一つだけの小窓。送信中の別作品の結果は各 entry に残す。
    function getDialog(state) {
        var existing = dialogs.get(state.documentRef);
        if (existing) { return existing; }
        var overlay = make(state, "dialog", "nk-up nk-up-dialog", "dialog");
        overlay.setAttribute("role", "dialog");
        overlay.setAttribute("aria-modal", "true");
        overlay.hidden = true;
        var panel = make(state, "div", "nk-up-dialog__panel");
        var grab = make(state, "div", "nk-up-dialog__grab");
        grab.setAttribute("aria-hidden", "true");
        var closeButton = make(state, "button", "nk-up-dialog__close", "close");
        closeButton.setAttribute("type", "button");
        setText(closeButton, "×");
        var work = make(state, "div", "nk-up-dialog__work");
        var image = make(state, "span", "nk-up-dialog__image", "dialog-image");
        image.setAttribute("aria-hidden", "true");
        var details = make(state, "div", "nk-up-dialog__details");
        var title = make(state, "p", "nk-up-dialog__title", "dialog-title");
        var date = make(state, "p", "nk-up-dialog__date", "dialog-date");
        // 商品ページの窓は UTC の行の下に、読む人の地域の曜日と時刻を1行添える（決定91・2026-09-27 オーナー決定）。
        // 札は地域の日付（例 Fri, Oct 9）なので、UTC の行だけだと同じ画面で曜日がずれて見える
        var localDate = make(state, "p", "nk-up-dialog__local", "dialog-local");
        details.appendChild(title);
        details.appendChild(date);
        details.appendChild(localDate);
        work.appendChild(image);
        work.appendChild(details);
        panel.appendChild(grab);
        panel.appendChild(closeButton);
        panel.appendChild(work);
        overlay.appendChild(panel);
        state.documentRef.body.appendChild(overlay);
        var view = state.documentRef.defaultView || runtime;
        var dialog = {
            overlay: overlay, panel: panel, closeButton: closeButton,
            image: image, title: title, date: date, localDate: localDate, view: view, entry: null, state: null
        };
        dialogs.set(state.documentRef, dialog);

        dialog.syncViewport = function () {
            var viewport = view.visualViewport;
            if (!viewport) { return; }
            // iPhoneのキーボードで縮んだ「見えている画面」の下端に合わせる。
            overlay.style.top = viewport.offsetTop + "px";
            overlay.style.left = viewport.offsetLeft + "px";
            overlay.style.width = viewport.width + "px";
            overlay.style.height = viewport.height + "px";
        };
        dialog.resize = function () {
            dialog.syncViewport();
            if (dialog.entry && !dialog.entry.form.hidden && typeof dialog.entry.send.scrollIntoView === "function") {
                dialog.entry.send.scrollIntoView({block: "nearest"});
            }
        };
        closeButton.addEventListener("click", function () { closeDialog(dialog); });
        overlay.addEventListener("click", function (event) {
            if (event.target === overlay) { closeDialog(dialog); }
        });
        overlay.addEventListener("cancel", function (event) {
            event.preventDefault();
            closeDialog(dialog);
        });
        overlay.addEventListener("keydown", function (event) {
            // 背景のクイック表示が持つ焦点制御へ操作を渡さない。
            event.stopPropagation();
            if (event.key === "Escape") { event.preventDefault(); }
            if (event.key !== "Tab" || !dialog.entry) { return; }
            var entry = dialog.entry;
            var focusable = [closeButton];
            if (!entry.form.hidden) {
                if (!entry.label || !entry.label.hidden) { focusable.push(entry.input); }
                if (!entry.send.disabled) { focusable.push(entry.send); }
                focusable.push(entry.cancel);
            }
            var index = focusable.indexOf(state.documentRef.activeElement);
            var next = event.shiftKey ? index - 1 : index + 1;
            if (next < 0 || next >= focusable.length) {
                event.preventDefault();
                focusable[event.shiftKey ? focusable.length - 1 : 0].focus();
            }
        });
        overlay.addEventListener("keyup", function (event) {
            // ImpulseはwindowのkeyupでEscを処理するため、小窓内で受け止めてから閉じる。
            event.stopPropagation();
            if (event.key === "Escape") { closeDialog(dialog); }
        });
        return dialog;
    }

    function closeDialog(dialog, restoreFocus) {
        if (!dialog.entry) { return; }
        var entry = dialog.entry;
        var closedState = dialog.state;
        var documentRef = dialog.state.documentRef;
        setHidden(entry.form, true);
        dialog.panel.removeChild(entry.form);
        entry.statusHome.appendChild(entry.status);
        // 2026-10-14 オーナー決定（#431）: 申し込めた後のお礼の文は、小窓を閉じたらボタンの下へ持ち帰らない
        if (entry.done || entry.mode === "stop") { showStatus(entry, ""); }
        dialog.entry = null;
        dialog.state = null;
        dialog.overlay.close();
        dialog.overlay.hidden = true;
        var viewport = dialog.view.visualViewport;
        if (viewport) {
            viewport.removeEventListener("resize", dialog.resize);
            viewport.removeEventListener("scroll", dialog.syncViewport);
        }
        Object.keys(dialog.bodyStyle).forEach(function (key) {
            documentRef.body.style[key] = dialog.bodyStyle[key];
        });
        if (documentRef.documentElement && dialog.htmlOverflow !== null) {
            documentRef.documentElement.style.overflow = dialog.htmlOverflow;
        }
        // iPhone はキーボードを出すとき止めた画面でも動かすことがあるので、開く前の位置へ戻す（同じ位置なら何も起きない）。
        if (typeof dialog.view.scrollTo === "function") {
            dialog.view.scrollTo(dialog.scrollX, dialog.scrollY);
        }
        if (restoreFocus !== false) { entry.notify.focus({preventScroll: true}); }
        // #431: 開いている間は見送った答え（別の端末・別のタブでの変更）を、閉じたこの札に当てる
        if (!closedState.destroyed) {
            var closedAt = closedState.now();
            var until = settleEntry(closedState, entry, null, closedAt);
            if (until) { scheduleSettle(closedState, until, closedAt); }
        }
    }

    // #431: 小窓の器を「申し込み（join）」と「取り消し（stop）」のどちらの形で見せるか。
    function applyMode(state, entry, mode) {
        var stopping = mode === "stop";
        entry.mode = stopping ? "stop" : "join";
        // #430: 申し込みの形では「販売開始の約10分前にメールでお知らせします」の1行を同じ場所に出す
        //   （予告品だけ。再入荷の小窓には文が渡されないので出ない）
        var leadText = stopping ? state.texts.stopTitle : (state.texts.remindNote || "");
        setText(entry.stopLead, leadText);
        setHidden(entry.stopLead, !leadText);
        // 会員と、印で取り消せる方にはメール欄を出さない。
        setHidden(entry.label, state.member || (stopping && stopsByKx(state, entry)));
        setText(entry.send, stopping ? state.texts.stopButton : state.texts.send);
        setText(entry.cancel, stopping ? state.texts.keepButton : state.texts.cancel);
        // #430: 小窓を開くたびに、送るボタンを「いま送っている最中か」だけで決め直す（前の操作の名残で押せないままにしない）
        entry.send.disabled = Boolean(entry.busy);
    }

    // 印で取り消すのは、ログインしていない方が印で申し込んだ品を印つきで開いたときだけ（ログイン中は会員のアドレス）
    function stopsByKx(state, entry) {
        return !memberIdentifier(state) && Boolean(state.kx) && entry.joinedVia === "kx";
    }

    function openForm(state, entry, mode) {
        var dialog = getDialog(state);
        if (dialog.entry) { closeDialog(dialog, false); }
        applyMode(state, entry, mode);
        dialog.entry = entry;
        dialog.state = state;
        dialog.overlay.setAttribute("aria-label", state.texts.emailLabel);
        dialog.closeButton.setAttribute("aria-label", entry.mode === "stop" ? state.texts.keepButton : state.texts.cancel);
        setText(dialog.title, entry.card.title);
        setText(dialog.date, entry.card.saleStartsAt === null ? "" : (state.productMode
            ? state.texts.whenLabel + " " + formatUtc(state.locale, entry.card.saleStartsAt) + " " + state.texts.utcSuffix
            : formatSaleDate(state, entry.card.saleStartsAt)));
        setHidden(dialog.date, entry.card.saleStartsAt === null);
        var localText = entry.card.saleStartsAt === null || !state.productMode ? ""
            : formatLocal(state.locale, entry.card.saleStartsAt, state.texts.localLine);
        setText(dialog.localDate, localText);
        setHidden(dialog.localDate, !localText);
        dialog.image.style.backgroundImage = "";
        setImage(dialog.image, entry.card.image, 160);
        setHidden(dialog.image, !entry.card.image);
        dialog.panel.appendChild(entry.form);
        dialog.panel.appendChild(entry.status);
        dialog.panel.scrollTop = 0;
        setHidden(entry.form, false);
        showStatus(entry, "");
        // 背景の位置を保ったまま、スクロールだけ止める。閉じる際はもとの指定をすべて戻す。
        // 🔴 2026-10-14 オーナー指摘（#431）: 本文を position:fixed で固定すると、ページの位置が
        //    いったん「一番上」と同じ扱いになり、縮んでいた上の帯（ヘッダー）が大きく戻っていた。
        //    だから本文は動かさず、html の overflow だけを止める（ページの位置は変わらない）。
        //    🛑 body には overflow を掛けない。掛けると body が「スクロールする箱」になり、上の帯（sticky）が
        //       body の一番上へ戻って画面から消える（2026-10-14 一時テーマで実測）。
        dialog.scrollX = dialog.view.scrollX || 0;
        dialog.scrollY = dialog.view.scrollY || 0;
        var documentElement = state.documentRef.documentElement;
        dialog.htmlOverflow = documentElement ? documentElement.style.overflow : null;
        dialog.bodyStyle = {};
        if (documentElement) { documentElement.style.overflow = "hidden"; }
        dialog.overlay.hidden = false;
        // ネイティブの小窓が背景を操作不可にし、読み上げの移動も内側に限定する。
        dialog.overlay.showModal();
        dialog.syncViewport();
        var viewport = dialog.view.visualViewport;
        if (viewport) {
            viewport.addEventListener("resize", dialog.resize);
            viewport.addEventListener("scroll", dialog.syncViewport);
        }
        // 🔴 2026-10-14 オーナー決定（#431）: 開いたときにメール欄へ焦点を合わせない。
        //    スマホでキーボードが勝手に出て、下端の小窓が持ち上がり隙間ができていた。
        //    会員はアドレスが最初から入っているので、キーボードを出す必要もない。焦点は閉じるボタンに置く。
        dialog.closeButton.focus({preventScroll: true});
    }

    function responseBody(response) {
        if (!response || typeof response.json !== "function") {
            return Promise.resolve(null);
        }
        return Promise.resolve(response.json()).catch(function () {
            return null;
        });
    }

    // 戻り先は同じ店の現在のパスとクエリだけ。申し込みのときだけ品番を引き継ぐ。
    function rememberLogin(state, code) {
        try {
            var view = state.view || runtime;
            if (!view.crypto || typeof view.crypto.getRandomValues !== "function") { return ""; }
            var bytes = new Uint8Array(16);
            view.crypto.getRandomValues(bytes);
            var token = Array.prototype.map.call(bytes, function (byte) {
                return ("0" + byte.toString(16)).slice(-2);
            }).join("");
            view.sessionStorage.setItem("nk_remind_return:" + code, token);
            return token;
        } catch (error) {
            // 保存できない端末では、戻った後にもう一度押してもらう。
            return "";
        }
    }

    function consumeLogin(state, code, token) {
        try {
            if (!/^[0-9a-f]{32}$/.test(token || "")) { return false; }
            var storage = (state.view || runtime).sessionStorage;
            var key = "nk_remind_return:" + code;
            if (storage.getItem(key) !== token) { return false; }
            storage.removeItem(key);
            return true;
        } catch (error) {
            return false;
        }
    }

    function loginHref(base, location, code, token) {
        if (!base || typeof runtime.URL !== "function" || !location || !location.href
                || /[\\\u0000-\u001f\u007f]/.test(base)) {
            return "";
        }
        try {
            var current = new runtime.URL(location.href);
            var url = new runtime.URL(base, current.href);
            if (!/^https?:$/.test(url.protocol) || url.origin !== current.origin) { return ""; }
            current.searchParams.delete("nk_remind");
            if (code) { current.searchParams.set("nk_remind", code); }
            current.searchParams.delete("nk_remind_token");
            if (code && token) { current.searchParams.set("nk_remind_token", token); }
            var back = current.pathname + current.search;
            if (url.pathname.indexOf("/customer_authentication/") === 0) {
                url = new runtime.URL("/customer_authentication/login", current.href);
                url.searchParams.set("return_to", back);
            } else {
                url.searchParams.set("return_url", back);
            }
            return url.toString();
        } catch (error) {
            return "";
        }
    }

    function locationOf(state) {
        return (state.view && state.view.location) || state.location;
    }

    function goLogin(state, entry, joining) {
        var code = joining ? entry.card.code : "";
        var token = code ? rememberLogin(state, code) : "";
        var href = loginHref(state.loginUrl, locationOf(state), code, token);
        var location = state.view && state.view.location;
        if (!href || !location || typeof location.assign !== "function") {
            showStatus(entry, state.texts.unavailable);
            return;
        }
        try {
            location.assign(href);
        } catch (error) {
            showStatus(entry, state.texts.unavailable);
        }
    }

    // ログインから戻った申し込みは、ページ内の同じ品をひとまとめにして一度だけ送る。
    function autoRemind(state) {
        var location = locationOf(state);
        var url;
        try {
            url = new runtime.URL(location.href);
        } catch (error) {
            return;
        }
        var code = url.searchParams.get("nk_remind");
        if (!CODE_PATTERN.test(code || "")) { return; }
        var target = state.entries.filter(function (entry) { return entry.card.code === code; })[0];
        if (!target) { return; }
        var key = state.documentRef;
        var claimed = remindedPages && remindedPages.get(key);
        if (!claimed) {
            claimed = state.hub.reminders || {};
            state.hub.reminders = claimed;
            if (remindedPages) { remindedPages.set(key, claimed); }
        }
        if (claimed[code]) { return; }
        if (!consumeLogin(state, code, url.searchParams.get("nk_remind_token"))) {
            // 外から来たリンクは対象を選ぶだけ。申し込みにはクリックが要る。
            if (target.notify && typeof target.notify.focus === "function") { target.notify.focus(); }
            clean();
            return;
        }
        claimed[code] = true;

        function clean() {
            var history = state.view && state.view.history;
            try {
                // 待っている間に変わった他のクエリやハッシュも、そのまま残す。
                var current = new runtime.URL(locationOf(state).href);
                current.searchParams.delete("nk_remind");
                current.searchParams.delete("nk_remind_token");
                if (history && typeof history.replaceState === "function") {
                    history.replaceState(history.state, "", current.pathname + current.search + current.hash);
                }
            } catch (error) {
                // 履歴を変えられなくても、このページの印で二重の申し込みは防ぐ。
            }
        }

        var attempts = 0;
        function attempt() {
            // 描画し直された札を毎回探し直す。待つ間に10分を切った品は送らない。
            target = state.entries.filter(function (entry) { return entry.card.code === code; })[0];
            if (state.destroyed || !target || target.done || target.busy
                    || target.card.state !== "coming" || remindClosedAt(target.card, state.now())) {
                clean();
                return;
            }
            if (canSend(state, {member: true})) {
                submit(state, target, {member: true}).then(clean, clean);
                return;
            }
            if (attempts >= 20) { clean(); return; }
            attempts += 1;
            state.setTimeoutRef(attempt, 250);
        }
        attempt();
    }

    // サーバーの返事を、今までの画面の言葉に写す。会員の失敗ではメール欄へ戻さない。
    function interpret(state, entry, response, body, via, stopping) {
        var texts = state.texts;
        var status = response ? response.status : 0;
        if (status === 200 && body && body.ok === true) {
            if (stopping) { return {stopped: true}; }
            remember(state, entry.card.code, via);
            noteLocalChange(state, entry.card.code, true);
            entry.joinedVia = via === "kx" ? "kx" : "email";
            markDone(state, entry);
            return {message: body.already ? texts.already : texts.done, done: true};
        }
        if (body && (body.code === "needs_account" || (status === 403 && body.code === "login_required"))) {
            return {login: true};
        }
        if (status === 404 && body && body.error === "profile not found") {
            return {login: true};
        }
        if (body && (body.code === "rate_limited" || body.code === "busy")) {
            return {message: texts.rateLimited};
        }
        if (via === "member" && body && (body.code === "no_email" || body.code === "account_deleted")) {
            return {message: texts.error};
        }
        if (status === 400) {
            return {message: via === "member" || stopping ? texts.error : texts.emailInvalid};
        }
        if (status === 404) { return {message: texts.unavailable}; }
        if (status === 429 || status === 503) { return {message: texts.rateLimited}; }
        return {message: texts.error};
    }

    // 会員は受け渡し口、印つきの方だけ直接の口へ。どちらもアドレスを本文に入れない。
    function canSend(state, identifier) {
        if (identifier && identifier.member) {
            var proxy = proxyOf(state);
            return state.member && proxy && typeof proxy.post === "function";
        }
        return identifier && identifier.kx && state.endpoint && typeof state.fetchRef === "function";
    }

    function sendNotify(state, entry, identifier, stopping) {
        var member = Boolean(identifier.member);
        var payload = {code: entry.card.code, locale: state.locale || "en"};
        if (member || stopping) { payload.action = stopping ? "cancel" : "join"; }
        if (!member) { payload.kx = identifier.kx; }
        var aborter = !member && typeof runtime.AbortController === "function" ? new runtime.AbortController() : null;
        var timer = aborter ? state.setTimeoutRef(function () {
            aborter.abort();
        }, REQUEST_TIMEOUT_MS) : null;
        var request = {
            method: "POST",
            mode: "cors",
            credentials: "omit",
            referrerPolicy: "origin",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(payload)
        };
        if (aborter) { request.signal = aborter.signal; }
        return Promise.resolve().then(function () {
            if (member) {
                return proxyOf(state).post(MEMBER_PATH, {body: payload, timeoutMs: REQUEST_TIMEOUT_MS})
                    .then(function (body) {
                        return interpret(state, entry, {status: body && body.status || 200}, body, "member", stopping);
                    });
            }
            return state.fetchRef(state.endpoint, request).then(function (response) {
                return responseBody(response).then(function (body) {
                    return interpret(state, entry, response, body, "kx", stopping);
                });
            });
        }).catch(function (error) {
            if (!member) { return {message: state.texts.unavailable}; }
            var kind = error && error.kind;
            if (kind === "rate_limited" || kind === "busy") { return {message: state.texts.rateLimited}; }
            if (kind === "not_found") { return {message: state.texts.unavailable}; }
            return {message: state.texts.error};
        }).then(function (outcome) {
            if (timer !== null) { state.clearTimeoutRef(timer); }
            return outcome;
        });
    }

    function submit(state, entry, identifier) {
        if (entry.busy || entry.done) { return Promise.resolve(); }
        if (!entry.card.code || entry.card.state !== "coming" || !canSend(state, identifier)) {
            showStatus(entry, state.texts.unavailable);
            return Promise.resolve();
        }
        setBusy(state, entry, true);
        showStatus(entry, "");
        return sendNotify(state, entry, identifier, false).then(function (outcome) {
            if (!entry.done) { setBusy(state, entry, false); }
            if (outcome.done) { setHidden(entry.form, true); }
            // お礼は小窓の中だけ。失敗の知らせは札にも残す。
            var shownDialog = dialogs.get(state.documentRef);
            var inDialog = shownDialog && shownDialog.entry === entry;
            showStatus(entry, outcome.done && !inDialog ? "" : outcome.message);
            if (outcome.login) { goLogin(state, entry, true); }
            settleHub(state.hub);
        });
    }

    // 取り消せたときだけ覚えを消し、同じ品の札を元のボタンへそろえる。
    function submitStop(state, entry, identifier) {
        if (entry.busy) { return Promise.resolve(); }
        if (!entry.card.code || !canSend(state, identifier)) {
            showStatus(entry, state.texts.unavailable);
            return Promise.resolve();
        }
        entry.busy = true;
        entry.notify.setAttribute("aria-disabled", "true");
        entry.send.disabled = true;
        setText(entry.send, state.texts.sending);
        showStatus(entry, "");
        return sendNotify(state, entry, identifier, true).then(function (outcome) {
            entry.busy = false;
            entry.send.disabled = false;
            setText(entry.send, state.texts.stopButton);
            var shownDialog = dialogs.get(state.documentRef);
            var inDialog = shownDialog && shownDialog.entry === entry;
            if (!outcome.stopped) {
                entry.notify.setAttribute("aria-disabled", "false");
                showStatus(entry, inDialog ? outcome.message : "");
                if (outcome.login) { goLogin(state, entry, false); }
                settleHub(state.hub);
                return;
            }
            unmarkDone(state, entry);
            noteLocalChange(state, entry.card.code, false);
            showStatus(entry, inDialog ? state.texts.stopped : "");
            if (inDialog) { shownDialog.closeButton.focus({preventScroll: true}); }
            settleHub(state.hub);
        });
    }

    function bindItem(state, entry) {
        entry.notify.addEventListener("click", function (event) {
            if (event && typeof event.preventDefault === "function") {
                event.preventDefault();
            }
            if (entry.busy) {
                return;
            }
            var dialog = dialogs.get(state.documentRef);
            if (entry.done) {
                if (!state.member && !stopsByKx(state, entry)) {
                    goLogin(state, entry, false);
                    return;
                }
                if (dialog && dialog.entry === entry) {
                    closeDialog(dialog);
                } else {
                    openForm(state, entry, "stop");
                }
                return;
            }
            if (!state.member) {
                if (state.kx) { submit(state, entry, {kx: state.kx}); }
                else { goLogin(state, entry, true); }
                return;
            }
            if (dialog && dialog.entry === entry) {
                closeDialog(dialog);
            } else {
                openForm(state, entry, "join");
            }
        });
        entry.send.addEventListener("click", function (event) {
            if (event && typeof event.preventDefault === "function") {
                event.preventDefault();
            }
            var stopping = entry.mode === "stop";
            if (stopping && stopsByKx(state, entry)) {
                submitStop(state, entry, {kx: state.kx});
                return;
            }
            var identifier = memberIdentifier(state);
            if (!identifier) {
                goLogin(state, entry, !stopping);
                return;
            }
            if (stopping) { submitStop(state, entry, identifier); }
            else { submit(state, entry, identifier); }
        });
        if (entry.input) {
            entry.input.addEventListener("keydown", function (event) {
                if (event && event.key === "Enter") {
                    if (typeof event.preventDefault === "function") {
                        event.preventDefault();
                    }
                    entry.send.click();
                }
            });
        }
        entry.cancel.addEventListener("click", function (event) {
            if (event && typeof event.preventDefault === "function") {
                event.preventDefault();
            }
            var dialog = dialogs.get(state.documentRef);
            if (dialog && dialog.entry === entry) { closeDialog(dialog); }
            showStatus(entry, "");
        });
    }

    function updateCells(entry, nowMs) {
        var parts = countdownParts(entry.card.saleStartsAt - nowMs);
        setText(entry.cells.days, String(parts.days));
        setText(entry.cells.hours, pad2(parts.hours));
        setText(entry.cells.minutes, pad2(parts.minutes));
        setText(entry.cells.seconds, pad2(parts.seconds));
    }

    function stateLabel(state, card, shortly) {
        if (card.state === "coming") { return shortly ? state.texts.shortly : state.texts.badge; }
        return card.state === "draw" ? state.texts.draw : (card.state === "sold" ? state.texts.sold : "");
    }

    /* 2026-09-22（#261）: 写真の上の札はオーナー指示で消したので、
       発売時刻を過ぎた品の「まもなく販売開始」を札に書いても誰にも見えない。
       残り時間の行を、0 の並びではなくその一言に差し替える。 */
    function updateShortlyLine(state, entry, shortly) {
        if (!entry.cdLabel) { return; }
        setText(entry.cdLabel, shortly ? (state.texts.shortly || state.texts.cdLabel) : state.texts.cdLabel);
        /* トップでは空の数字枠を隠す（スマホ幅は畳んで2行ぶんの高さをCSSで確保・PC幅は幅0で高さを残す
           ＝2026-09-27）。一覧・商品ページは従来の寸法を保つ。判定をCSSの :has() に任せない。 */
        if (shortly) { entry.countdown.classList.add("is-blank"); }
        else { entry.countdown.classList.remove("is-blank"); }
        if (entry.cellsBox) {
            if (shortly) { entry.cellsBox.setAttribute("data-nk-cells-blank", "1"); }
            else { entry.cellsBox.removeAttribute("data-nk-cells-blank"); }
        }
    }

    /* #430（2026-10-14）: お知らせは販売開始の約10分前（0:50）に1回だけ送る。それを過ぎてから申し込んでも
       メールは届かないので、販売開始まで10分を切ったら新しい申し込みのボタンを畳む（申し込み済みの ✓ は残す）。 */
    var REMIND_CLOSE_MS = 10 * 60 * 1000;

    function remindClosedAt(card, nowMs) {
        return card.state === "coming" && card.saleStartsAt !== null && card.saleStartsAt - nowMs <= REMIND_CLOSE_MS;
    }

    function updateEntry(state, entry, nowMs) {
        var shortly = entry.card.state === "coming" && entry.card.saleStartsAt !== null && entry.card.saleStartsAt <= nowMs;
        var remindClosed = remindClosedAt(entry.card, nowMs);
        // 端末の時計が戻ったときは印を外す（残り時間の欄の印と同じ扱い）
        if (remindClosed) {
            entry.element.setAttribute("data-nk-remind-closed", "1");
            if (state.productMode) { state.root.setAttribute("data-nk-remind-closed", "1"); }
        } else {
            entry.element.removeAttribute("data-nk-remind-closed");
            if (state.productMode) { state.root.removeAttribute("data-nk-remind-closed"); }
        }
        updateCells(entry, nowMs);
        setText(entry.badge, stateLabel(state, entry.card, shortly));
        updateShortlyLine(state, entry, shortly);
        /* #301: 開いたまま発売時刻をまたいだら、発売日の1行も過去の日付のまま残さない */
        if (shortly && entry.saleDate) {
            setText(entry.saleDate, formatSaleDate(state, entry.card.saleStartsAt));
        }
        if (shortly) {
            entry.element.setAttribute("data-nk-state-phase", "shortly");
            if (state.productMode) { state.root.setAttribute("data-nk-state-phase", "shortly"); }
        }
        if (state.productMode) {
            setText(find(state.root, "coming-title"), shortly ? state.texts.shortly : state.texts.comingTitle);
            // #430: 10分を切ったら「約10分前にお知らせできます」の説明も「まもなく販売」の案内へ（ボタンを畳むのと同時）
            setText(find(state.root, "coming-lead"), shortly || remindClosed ? state.texts.shortlyNote : state.texts.comingLead);
        }
    }

    // ---------------------------------------------------------------
    // #430: ログイン中の会員の ✓ をサーバーの申し込みに合わせる
    // ---------------------------------------------------------------

    // 受け渡し口は init のときにはまだ読み込まれていないことがある（defer の順番）ので、使うときに探す
    function proxyOf(state) {
        return state.proxy !== undefined ? state.proxy : (runtime.NKAppProxy || null);
    }

    /* 問い合わせるのは、ログイン中で・受け渡し口があり・販売開始まで10分より先の予告の札が1つ以上あるときだけ。
       10分を切った札（data-nk-remind-closed）は申し込みのボタンを畳むので、それだけのページでは問い合わせない
       （答えが届いたときの当て直しは、10分を切った札にも行う）。 */
    function canSyncMember(state) {
        var proxy = proxyOf(state);
        if (!state.member || !proxy || typeof proxy.get !== "function") {
            return false;
        }
        var nowMs = state.now();
        if (inBusyHour(nowMs)) {
            return false;
        }
        return state.entries.some(function (entry) {
            return entry.card.state === "coming" && Boolean(entry.card.code) && !remindClosedAt(entry.card, nowMs);
        });
    }

    /* #430 見直し: 毎日 0:40〜1:40（日本時間＝15:40〜16:40 UTC）は問い合わせない。
       販売開始（1:00）の前後はお客さまが最も多く、作業部屋A の「外を待つ時間の枠」を抽選の応募などと取り合うため
       （そろえは便利のためのもので、問い合わせなくてもその端末の覚えで動く）。 */
    function inBusyHour(nowMs) {
        var date = new Date(nowMs);
        var minutes = date.getUTCHours() * 60 + date.getUTCMinutes();
        return minutes >= 15 * 60 + 40 && minutes < 16 * 60 + 40;
    }

    // 会員の見分けはテーマの属性だけで行い、アドレスの有無や欄の値に依存させない。
    function memberIdentifier(state) {
        return state.member ? {member: true} : null;
    }

    /* 返事の形を確かめる。ok で・品番（7桁）だけの配列のときだけ使う（それ以外は今の覚えのまま）。
       #431: profile が false（Klaviyo にまだ居ない＝申し込みの直後で人がまだ引けないことがある）の答えは
       「分からない」として使わない（空の一覧で ✓ を外さない・作り直した札でもこの端末の記録を残す） */
    function pendingFrom(result) {
        if (!result || typeof result !== "object" || result.ok !== true || !Array.isArray(result.pending)
                || result.pending.length > MAX_STATUS_CODES || result.profile === false) {
            return null;
        }
        var pending = {};
        for (var index = 0; index < result.pending.length; index += 1) {
            var code = result.pending[index];
            if (typeof code !== "string" || !CODE_PATTERN.test(code)) {
                return null;
            }
            pending[code] = true;
        }
        return pending;
    }

    // この端末での、その品のいちばん新しい記録（このページの中と端末の覚えの新しいほう・同じ時刻ならこのページの中）
    function latestRecord(state, code, nowMs) {
        var mine = state.hub ? state.hub.local[code] || null : null;
        var stored = storedRecord(state, code, nowMs);
        if (mine && stored) {
            return stored.at > mine.at ? stored : mine;
        }
        return mine || stored;
    }

    // 1分を過ぎた記録を、答えが無いときの決め手にしてよいか。
    // ログイン中は ✓ の覚えがサーバーの答えで書き直されている＝古い記録で開き直したときに戻さない（このページの中の記録だけ使う）
    function oldRecordUsable(state, record) {
        var hub = state.hub;
        return !state.member || Boolean(hub && hub.local[record.code] === record);
    }

    /* #431: 1枚の札を、いちばん新しい事実に合わせる。決め方の順:
       ①この端末で1分以内に申し込み・取り消しをした記録 → ②サーバーの答え（ログイン中で、答えが届いていれば）
       → ③この端末の記録（古くても・答えが無いとき）→ ④どれも無ければ触らない。
       送っている最中の札・小窓が開いている札は触らない（閉じたとき・送り終えたときにもう一度呼ばれる）。
       ①で決めた札は、1分が過ぎた時刻を返す（その時刻にもう一度そろえ直す）。 */
    function settleEntry(state, entry, dialog, nowMs) {
        var code = entry.card.code;
        if (!code || entry.card.state !== "coming" || entry.busy || entry.disposed) {
            return 0;
        }
        if (dialog && dialog.entry === entry) {
            return 0;
        }
        var hub = state.hub;
        var record = latestRecord(state, code, nowMs);
        if (record) {
            record.code = code;
        }
        var fresh = record && record.at <= nowMs && nowMs - record.at < LOCAL_GRACE_MS;
        var joined;
        var fromServer = false;
        if (fresh) {
            joined = record.joined;
        } else if (hub && hub.pending) {
            joined = Object.prototype.hasOwnProperty.call(hub.pending, code);
            fromServer = true;
        } else if (record && oldRecordUsable(state, record)) {
            joined = record.joined;
        } else {
            return 0;
        }
        if (joined && !entry.done) {
            if (fromServer) {
                remember(state, code, "synced");
            }
            entry.joinedVia = rememberedVia(state, code) || "email";
            markDone(state, entry);
        } else if (!joined && entry.done) {
            // サーバーの答えで外さない: 販売開始まで10分を切った札
            // （0:50 にお知らせを送ると、その品はサーバーの「まだ送っていない申し込み」から外れるため）
            if (!(fromServer && remindClosedAt(entry.card, nowMs))) {
                unmarkDone(state, entry);
            }
        }
        return fresh ? record.at + LOCAL_GRACE_MS : 0;
    }

    function settleState(state) {
        if (!state || state.destroyed) {
            return;
        }
        var dialog = dialogs.get(state.documentRef);
        var nowMs = state.now();
        var due = 0;
        state.entries.forEach(function (entry) {
            var until = settleEntry(state, entry, dialog, nowMs);
            if (until && (!due || until < due)) {
                due = until;
            }
        });
        if (due) {
            scheduleSettle(state, due, nowMs);
        }
    }

    function settleHub(hub) {
        if (!hub) {
            return;
        }
        pruneHub(hub);
        hub.states.slice().forEach(settleState);
    }

    // 1分の記録が切れる時刻に、もう一度そろえ直す（その間に届いたサーバーの答えを当てる）。待ちの時計はページで1本
    function scheduleSettle(state, due, nowMs) {
        var hub = state.hub;
        if (!hub || hub.closed || typeof state.setTimeoutRef !== "function") {
            return;
        }
        if (hub.settleTimer !== null) {
            if (hub.settleDue <= due) {
                return;
            }
            if (typeof hub.clearSettle === "function") {
                hub.clearSettle(hub.settleTimer);
            }
        }
        hub.settleDue = due;
        hub.clearSettle = state.clearTimeoutRef;
        hub.settleTimer = state.setTimeoutRef(function () {
            hub.settleTimer = null;
            hub.settleDue = 0;
            if (!hub.closed) {
                settleHub(hub);
            }
        }, Math.max(0, due - nowMs) + 50);
    }

    // ---------------------------------------------------------------
    // #431: ページに1つの「そろえ役」（問い合わせ・知らせの受け口をまとめる）
    // ---------------------------------------------------------------

    function addListener(target, type, listener, hub) {
        if (target && typeof target.addEventListener === "function") {
            target.addEventListener(type, listener);
            hub.listeners.push([target, type, listener]);
        }
    }

    function joinHub(state) {
        var key = state.documentRef;
        var hub = hubs && key ? hubs.get(key) : null;
        if (!hub) {
            hub = {
                key: key, states: [], revision: 0, inflight: null, started: false, touched: {}, local: {},
                seenAt: {}, answerAt: 0,
                pending: null, timer: null, clearTimer: null, settleTimer: null, settleDue: 0, clearSettle: null,
                listeners: [], closed: false
            };
            if (hubs && key) {
                hubs.set(key, hub);
            }
            // 画面に戻ったとき: 別のタブの記録を当て直し、別の端末で変えた分を問い合わせる（1分に1回まで）
            addListener(key, "visibilitychange", function () {
                if (key.visibilityState !== "hidden") {
                    settleHub(hub);
                    requestSync(hub, "visible");
                }
            }, hub);
            // 戻る操作で保存されたページを開き直したとき（止まっている間の変更を拾う・新しく開いたのと同じ扱い）
            addListener(state.view, "pageshow", function (event) {
                if (event && event.persisted) {
                    settleHub(hub);
                    requestSync(hub, "resume");
                }
            }, hub);
            // 同じ端末の別のタブで変えた分
            addListener(state.view, "storage", function (event) {
                onStorage(hub, event);
            }, hub);
        }
        pruneHub(hub);
        hub.states.push(state);
        state.hub = hub;
        return hub;
    }

    // 片付けた部品を外す。最後の1つなら、受け口・待ちの時計を外し、届く前の答えも捨てる
    function leaveHub(state) {
        var hub = state.hub;
        if (!hub) {
            return;
        }
        hub.states = hub.states.filter(function (other) { return other !== state; });
        if (hub.states.length) {
            return;
        }
        hub.closed = true;
        hub.revision += 1;
        hub.inflight = null;
        if (hub.timer !== null && typeof hub.clearTimer === "function") {
            hub.clearTimer(hub.timer);
        }
        hub.timer = null;
        if (hub.settleTimer !== null && typeof hub.clearSettle === "function") {
            hub.clearSettle(hub.settleTimer);
        }
        hub.settleTimer = null;
        hub.listeners.forEach(function (item) {
            if (typeof item[0].removeEventListener === "function") {
                item[0].removeEventListener(item[1], item[2]);
            }
        });
        hub.listeners = [];
        if (hubs && hub.key && hubs.get(hub.key) === hub) {
            hubs.delete(hub.key);
        }
    }

    // 部品を片付ける（外から destroy を呼んだとき・ページから取り外されていたとき）
    function destroyState(state) {
        if (state.destroyed) {
            return;
        }
        state.entries.forEach(function (entry) { entry.disposed = true; });
        var dialog = dialogs.get(state.documentRef);
        if (dialog && dialog.state === state) { closeDialog(dialog); }
        stopTimer(state);
        // #430/#431: 届く前の答えは捨て、最後の部品ならページの受け口・待ちの時計も外す
        state.destroyed = true;
        leaveHub(state);
    }

    /* ページから取り外された部品（クイック表示の入れ替え・テーマ編集の節の外し）を片付ける。
       isConnected を持たない古い仕組みでは、取り外されたと分からないので何もしない */
    function pruneHub(hub) {
        hub.states.slice().forEach(function (state) {
            if (state.root && state.root.isConnected === false) {
                destroyState(state);
            }
        });
    }

    /* 別のタブの変更の知らせ。
       ・申し込み・取り消しの記録（nk-upcoming-notify-at:）＝人が押した変更: このページの答えにも写し（届く前の問い合わせの
         答えにも）、札をそろえる
       ・✓ の覚え（nk-upcoming-notify:）だけの変更＝サーバーの答えで付け外ししたもの: このページの答えは変えない
         （別のタブの古い答えで、こちらの新しい答えを上書きしない・タブの間で行ったり来たりさせない） */
    function onStorage(hub, event) {
        if (hub.closed || !event || typeof event.key !== "string" || event.key.indexOf(LOCAL_AT_PREFIX) !== 0) {
            return;
        }
        var code = event.key.slice(LOCAL_AT_PREFIX.length);
        var record = parseRecord(event.newValue);
        if (!CODE_PATTERN.test(code) || !record) {
            return;
        }
        // 遅れて届いた古い知らせ（このページが知っている記録・届いている答えより前の操作）では答えを変えない
        if (record.at >= (hub.seenAt[code] || 0) && record.at >= hub.answerAt) {
            hub.seenAt[code] = record.at;
            hub.touched[code] = record.joined;
            if (hub.pending) {
                if (record.joined) {
                    hub.pending[code] = true;
                } else {
                    delete hub.pending[code];
                }
            }
        }
        settleHub(hub);
    }

    // 問い合わせてよい部品（ログイン中・受け渡し口あり・10分より先の予告の札あり・混む時間の外）
    function syncLead(hub) {
        for (var index = 0; index < hub.states.length; index += 1) {
            var state = hub.states[index];
            if (!state.destroyed && canSyncMember(state)) {
                return state;
            }
        }
        return null;
    }

    // この端末で最後に問い合わせた時刻（タブをまたいで共有）。覚えが使えないときはこのページの中の時刻
    function lastSyncAt(hub, state, nowMs) {
        var at = hub.lastAt || 0;
        if (state.storage) {
            try {
                var value = state.storage.getItem(SYNC_AT_KEY);
                if (typeof value === "string" && /^\d{1,16}$/.test(value)) {
                    at = Math.max(at, Number(value));
                }
            } catch (error) {
                // 読めなければ、このページの中の時刻だけで決める。
            }
        }
        // 時計が戻った（覚えの時刻が未来）ときは、待たない
        return at > nowMs ? 0 : at;
    }

    function markSyncAt(hub, state, nowMs) {
        hub.lastAt = nowMs;
        if (!state.storage) {
            return;
        }
        try {
            state.storage.setItem(SYNC_AT_KEY, String(Math.floor(nowMs)));
        } catch (error) {
            // 覚えられなくても、このページの中では1分に1回が守られる。
        }
    }

    /* 問い合わせの入口。kind:
       "init"＝部品を開いた（ページで最初の1回は待たずに出す・出している途中なら相乗り・2回目からは "visible" と同じ）
       "resume"・"force"＝必ず新しく出す（出している途中の答えは捨てる）
       "visible"＝画面に戻った（出している途中なら相乗り・この端末で1分以内に出していれば残りを待って1回だけ） */
    function requestSync(hub, kind) {
        if (hub.closed) {
            return Promise.resolve();
        }
        pruneHub(hub);
        if (hub.closed) {
            return Promise.resolve();
        }
        var state = syncLead(hub);
        if (!state) {
            return Promise.resolve();
        }
        if ((kind === "init" || kind === "visible") && hub.inflight) {
            return hub.inflight;
        }
        // 後から足した部品（クイック表示など）は、覚えている答えを当てるだけ（render 済み）。問い合わせは1分に1回まで
        var asked = hub.started || Boolean(syncedPages && hub.key && syncedPages.has(hub.key));
        if (kind === "visible" || (kind === "init" && asked)) {
            var nowMs = state.now();
            var wait = RESYNC_MIN_MS - (nowMs - lastSyncAt(hub, state, nowMs));
            if (wait > 0) {
                scheduleSync(hub, state, wait);
                return Promise.resolve();
            }
        }
        return startSync(hub, state);
    }

    function scheduleSync(hub, state, wait) {
        if (hub.timer !== null || typeof state.setTimeoutRef !== "function") {
            return;
        }
        hub.clearTimer = state.clearTimeoutRef;
        hub.timer = state.setTimeoutRef(function () {
            hub.timer = null;
            // 待つ間に画面から離れていたら出さない（次に戻ったときに出す）
            if (hub.closed || (hub.key && hub.key.visibilityState === "hidden")) {
                return;
            }
            requestSync(hub, "visible");
        }, wait);
    }

    function startSync(hub, state) {
        var nowMs = state.now();
        // 新しい問い合わせを始めたら、前の問い合わせの答えは捨てる
        var revision = ++hub.revision;
        hub.started = true;
        if (syncedPages && hub.key) {
            syncedPages.set(hub.key, true);
        }
        hub.touched = {};
        markSyncAt(hub, state, nowMs);
        var request;
        try {
            // v は毎回いまの時刻（サーバーの「20秒の使い回し」を受けない＝別の端末での変更をすぐ拾う）。
            // 失敗しても画面は今までどおりで困らないので、繰り返さない（混んだ瞬間に問い合わせを倍にしない）
            request = proxyOf(state).get(STATUS_PATH, {
                query: {v: String(Math.floor(nowMs))}, retry: false, timeoutMs: STATUS_TIMEOUT_MS
            });
        } catch (error) {
            return Promise.resolve();
        }
        var promise = Promise.resolve(request).then(function (result) {
            if (revision !== hub.revision || hub.closed) {
                return;
            }
            var pending = pendingFrom(result);
            if (!pending) {
                return;
            }
            // 答えを待つ間にこの端末（別のタブを含む）で申し込み・取り消しをした品は、この端末の今の状態を正とする
            Object.keys(hub.touched).forEach(function (code) {
                if (hub.touched[code]) {
                    pending[code] = true;
                } else {
                    delete pending[code];
                }
            });
            hub.pending = pending;
            // この答えより前に始まった操作の、遅れて届く知らせでは答えを変えない
            hub.answerAt = Math.max(hub.answerAt, nowMs);
            settleHub(hub);
        }, function () {
            // 失敗・口が閉じている（404）・未ログイン（401）・混み合い（429/503）・時間切れ: 今の覚えのまま（何も変えない）
        }).then(function () {
            if (hub.inflight === promise) {
                hub.inflight = null;
            }
        });
        hub.inflight = promise;
        return promise;
    }

    /* ページを読み終えてから（DOMContentLoaded の後に）1回だけ呼ぶ。
       受け渡し口（nk-app-proxy.js）は節の中で defer で読む＝head にあるこの部品より後に走るため。 */
    function whenDomReady(state, callback) {
        var documentRef = state.documentRef;
        if (domReady || !documentRef || documentRef.readyState === "complete") {
            callback();
            return;
        }
        if (typeof documentRef.addEventListener !== "function") {
            return;
        }
        var called = false;
        function once() {
            if (called) {
                return;
            }
            called = true;
            callback();
        }
        documentRef.addEventListener("DOMContentLoaded", once);
        // 万一 DOMContentLoaded の後に読み込まれても、読み込みの終わり（load）で1回
        var view = documentRef.defaultView || runtime;
        if (view && typeof view.addEventListener === "function") {
            view.addEventListener("load", once);
        }
    }

    /* 2026-09-22: 横スライドの帯。はみ出していないときは出さない。
       計算は絵師の段（nk-artists）と同じ＝つまみの幅＝見えている割合。 */
    function syncRail(state) {
        if (!state.rail || !state.railThumb || !state.itemsBox) {
            return;
        }
        var track = state.itemsBox;
        var ratio = track.clientWidth / track.scrollWidth;
        if (!isFinite(ratio) || ratio >= 1) {
            setHidden(state.rail, true);
            return;
        }
        setHidden(state.rail, false);
        var pct = Math.max(8, ratio * 100);
        state.railThumb.style.width = pct.toFixed(2) + "%";
        var max = track.scrollWidth - track.clientWidth;
        var pos = max > 0 ? track.scrollLeft / max : 0;
        state.railThumb.style.left = (pos * (100 - pct)).toFixed(2) + "%";
    }

    function bindRail(state) {
        if (state.railBound || !state.itemsBox) {
            return;
        }
        state.railBound = true;
        state.itemsBox.addEventListener("scroll", function () {
            syncRail(state);
        }, {passive: true});
    }

    /* 2026-09-22 オーナー決定: 横スライドの一番右に「もっと見る」カードを置く。
       🛑 追加の品が無いときは出さない（右上のリンクと同じ条件）。 */
    function updateEndCard(state, hiddenCount, totalCount) {
        if (!state.itemsBox || state.productMode) {
            return;
        }
        /* ⚠️ 検索（querySelector）で探さない。試験用の軽いDOMはクラス検索に対応していないため、
              作った札そのものを state に覚えておく（メモリ「偽の画面で試すテスト」の型） */
        if (!(hiddenCount > 0 && state.viewAllUrl)) {
            if (state.endCard && state.endCard.parentNode) {
                state.endCard.parentNode.removeChild(state.endCard);
            }
            state.endCard = null;
            return;
        }
        if (state.endCard && state.endCard.parentNode === state.itemsBox) {
            return;
        }
        var link = state.documentRef.createElement("a");
        link.className = "nk-up__endcard";
        link.setAttribute("href", state.viewAllUrl);
        var text = state.documentRef.createElement("span");
        text.className = "nk-up__endtext";
        /* 2026-09-23 オーナー決定: 出す数字は「残り」ではなく「全部の数」（新着の段と同じ意味）。
           出すか出さないかは今までどおり「まだ見せていない品があるか」で決める。 */
        setText(text, fillTemplate(state.texts.viewAll, {count: totalCount}));
        link.appendChild(text);
        state.itemsBox.appendChild(link);
        state.endCard = link;
    }

    function updateViewAll(state, hiddenCount, totalCount) {
        if (!state.viewAll) {
            return;
        }
        if (hiddenCount > 0 && state.viewAllUrl) {
            setText(state.viewAll.querySelector("span") || state.viewAll, fillTemplate(state.texts.viewAll, {count: totalCount}));
            setHidden(state.viewAll, false);
        } else {
            setHidden(state.viewAll, true);
        }
    }

    function stopTimer(state) {
        if (state.timer !== null && typeof state.clearIntervalRef === "function") {
            state.clearIntervalRef(state.timer);
            state.timer = null;
        }
    }

    function tick(state) {
        // ページから取り外された部品（クイック表示の入れ替えなど）は、秒の時計ごと片付ける
        if (state.root && state.root.isConnected === false) {
            destroyState(state);
            return;
        }
        var nowMs = state.now();
        var future = false;
        state.entries.forEach(function (entry) {
            updateEntry(state, entry, nowMs);
            if (entry.card.state === "coming" && entry.card.saleStartsAt !== null && entry.card.saleStartsAt > nowMs) {
                future = true;
            }
        });
        // 0で止まった札と通知は残し、秒の時計だけを止める。
        if (!future) { stopTimer(state); }
    }

    function render(state) {
        state.entries.forEach(function (entry) { entry.disposed = true; });
        var dialog = dialogs.get(state.documentRef);
        if (dialog && dialog.state === state) { closeDialog(dialog); }
        var nowMs = state.now();
        var cards = state.cards;
        var shown = state.max > 0 ? cards.slice(0, state.max) : cards;

        if (state.itemsBox) {
            while (state.itemsBox.firstChild) {
                state.itemsBox.removeChild(state.itemsBox.firstChild);
            }
            state.endCard = null;
        }
        state.entries = [];
        if (!shown.length || !state.itemsBox) {
            // 商品データが不正でも、Liquidで描いた見出しと一文は残す。
            setHidden(state.root, !state.productMode);
            stopTimer(state);
            updateViewAll(state, 0);
            updateEndCard(state, 0);
            setHidden(state.rail, true);
            return;
        }
        shown.forEach(function (card) {
            var entry = buildItem(state, card);
            updateEntry(state, entry, nowMs);
            state.itemsBox.appendChild(entry.element);
            state.entries.push(entry);
        });
        // #430: 作り直した札にも、覚えているサーバーの答えを当て直す（この端末に覚えを書けない環境でも ✓ をそろえる）
        settleState(state);
        var totalCount = Math.max(cards.length, state.totalCount);
        var hiddenCount = totalCount - shown.length;
        updateViewAll(state, hiddenCount, totalCount);
        updateEndCard(state, hiddenCount, totalCount);
        setHidden(state.root, false);
        bindRail(state);
        syncRail(state);
        if (state.timer === null && cards.some(function (card) { return card.state === "coming" && card.saleStartsAt !== null && card.saleStartsAt > nowMs; }) && typeof state.setIntervalRef === "function") {
            state.timer = state.setIntervalRef(function () {
                tick(state);
            }, SECOND_MS);
        }
        if (state.documentRef && typeof state.documentRef.dispatchEvent === "function" && typeof runtime.CustomEvent === "function") {
            state.documentRef.dispatchEvent(new runtime.CustomEvent("nk:cards-added"));
        }
    }

    function init(root, options) {
        if (!root || !root.dataset || typeof root.querySelector !== "function") {
            return null;
        }
        if (root.dataset.nkUpcomingInitialized === "true") {
            return controllers ? controllers.get(root) || null : null;
        }
        root.dataset.nkUpcomingInitialized = "true";
        var settings = options || {};
        var documentRef = settings.documentRef || runtime.document || root.ownerDocument;
        var location = settings.location
            || (documentRef && documentRef.location)
            || runtime.location
            || null;
        var storage = null;
        if (settings.storage !== undefined) {
            storage = settings.storage;
        } else {
            try {
                storage = runtime.localStorage || null;
            } catch (error) {
                storage = null;
            }
        }
        var state = {
            root: root,
            documentRef: documentRef,
            fetchRef: settings.fetch || (typeof runtime.fetch === "function"
                ? function (url, request) {
                    return runtime.fetch(url, request);
                }
                : null),
            now: settings.now || function () {
                return Date.now();
            },
            // ⚠️ window から切り離して呼ぶと「Illegal invocation」で落ちるので、必ず包む。
            setIntervalRef: settings.setInterval || function (callback, delay) {
                return runtime.setInterval(callback, delay);
            },
            clearIntervalRef: settings.clearInterval || function (timer) {
                return runtime.clearInterval(timer);
            },
            setTimeoutRef: settings.setTimeout || function (callback, delay) {
                return runtime.setTimeout(callback, delay);
            },
            clearTimeoutRef: settings.clearTimeout || function (timer) {
                return runtime.clearTimeout(timer);
            },
            storage: storage,
            productMode: root.getAttribute("data-nk-upcoming-mode") === "product",
            totalCount: 0,
            locale: root.getAttribute("data-nk-upcoming-locale") || "",
            endpoint: (root.getAttribute("data-nk-upcoming-endpoint") || "").trim(),
            loginUrl: (root.getAttribute("data-nk-upcoming-login-url") || "").trim(),
            location: location,
            max: parseInt(root.getAttribute("data-nk-upcoming-max") || "0", 10) || 0,
            viewAllUrl: (root.getAttribute("data-nk-upcoming-view-all-url") || "").trim(),
            kx: kxFromLocation(location),
            texts: readTexts(root),
            itemsBox: find(root, "items"),
            viewAll: find(root, "view-all"),
            // 2026-09-22: 横スライドの帯（絵師の段と同じ計算でスクロールに連動させる）
            rail: find(root, "rail"),
            railThumb: find(root, "rail-thumb"),
            railBound: false,
            endCard: null,
            cards: [],
            entries: [],
            timer: null,
            // #430: ログイン中（会員のメールの属性がある）だけ、サーバーの申し込みに ✓ を合わせる
            member: root.getAttribute("data-nk-upcoming-customer-email") !== null,
            memberEmail: (root.getAttribute("data-nk-upcoming-customer-email") || "").trim(),
            proxy: settings.proxy,
            // #431: ページに1つの「そろえ役」と、その受け口を付ける先（window）
            hub: null,
            view: settings.view !== undefined ? settings.view : ((documentRef && documentRef.defaultView) || runtime),
            destroyed: false
        };
        // 送り先は https だけ。テーマの設定が壊れていても、平文や別の仕組みへ送らない。
        if (!/^https:\/\/[^\s"'<>]+$/i.test(state.endpoint)) {
            state.endpoint = "";
        }
        if (state.viewAll && state.viewAllUrl) {
            state.viewAll.setAttribute("href", state.viewAllUrl);
        }
        joinHub(state);
        var payload = readInlinePayload(root);
        state.cards = normalizeCards(payload);
        state.totalCount = payload && Number.isInteger(payload.total_count) && payload.total_count > 0 ? payload.total_count : state.cards.length;
        render(state);

        var controller = {
            cards: function () {
                return state.cards.slice();
            },
            visible: function () {
                return state.entries.map(function (entry) {
                    return entry.card;
                });
            },
            render: function () {
                render(state);
            },
            tick: function () {
                tick(state);
            },
            notify: function (code, identifier) {
                var target = null;
                state.entries.forEach(function (entry) {
                    if (entry.card.code === code) {
                        target = entry;
                    }
                });
                // 外から渡されたメールや印では本人を選ばず、このページの会員か印だけを使う。
                var own = memberIdentifier(state) || (state.kx ? {kx: state.kx} : null);
                return target && own ? submit(state, target, own) : Promise.resolve();
            },
            destroy: function () {
                destroyState(state);
            },
            // #430: サーバーの申し込みに合わせ直す（検査と、外から呼び直したいとき用・待たずに新しく出す）
            sync: function () {
                return state.hub ? requestSync(state.hub, "force") : Promise.resolve();
            }
        };
        if (controllers) {
            controllers.set(root, controller);
        }
        if (state.member) {
            autoRemind(state);
            // 画面に戻ったとき・戻る操作で開き直したときの問い合わせは、そろえ役（joinHub）が受ける
            whenDomReady(state, function () {
                if (state.hub) {
                    requestSync(state.hub, "init");
                }
            });
        }
        return controller;
    }

    function autoInit() {
        if (!runtime.document || typeof runtime.document.querySelectorAll !== "function") {
            return [];
        }
        return Array.prototype.slice.call(
            runtime.document.querySelectorAll("[data-nk-upcoming-root]")
        ).map(function (root) {
            return init(root);
        });
    }

    var NKUpcoming = {
        init: init,
        autoInit: autoInit,
        normalizeCard: normalizeCard,
        normalizeCards: normalizeCards,
        countdownParts: countdownParts,
        formatUtc: formatUtc,
        formatLocal: formatLocal,
        formatPrice: formatPrice,
        sanitizeHtml: sanitizeHtml,
        sizedImageUrl: sizedImageUrl,
        parseTime: parseTime,
        validEmail: validEmail
    };

    if (typeof runtime.document !== "undefined" && runtime.document) {
        runtime.NKUpcoming = NKUpcoming;
        if (typeof runtime.document.addEventListener === "function") {
            // #430: 先に登録しておき、ページを読み終えたかを覚える（会員の ✓ の問い合わせはそれより後）
            runtime.document.addEventListener("DOMContentLoaded", function () {
                domReady = true;
            });
            // 素体のクイック表示とテーマ編集で差し込まれた案内も同じ初期化を通す。
            runtime.document.addEventListener("quickview:loaded", autoInit);
            runtime.document.addEventListener("shopify:section:load", autoInit);
        }
        if (runtime.document.readyState === "loading"
                && typeof runtime.document.addEventListener === "function") {
            runtime.document.addEventListener("DOMContentLoaded", function () {
                autoInit();
            });
        } else {
            autoInit();
        }
    }
    if (typeof module === "object" && module && module.exports) {
        module.exports = NKUpcoming;
    }
})(typeof window !== "undefined" ? window : globalThis);
